import { parse, stringify } from 'query-string';

import { parseFilterValues } from './filter-parser';
import { FilterKey, FilterValuesObject, SortKey } from './filters';

export abstract class FilterMapper {
  protected basePathname: string;

  constructor(basePathname: string) {
    this.basePathname = basePathname;
  }

  public abstract serialize(filterMap: FilterValuesObject): string;

  public abstract deserialize(url: string): FilterValuesObject;

  protected static stringifyQueryString(value: object): string {
    const adjustedValue = Object.assign(
      {} as Record<string, SortKey | string | (number | string)[] | undefined>,
      value
    );

    const implicitFilters = [FilterKey.VIEW];
    implicitFilters.forEach((key) => {
      if (key in adjustedValue) {
        delete adjustedValue[key];
      }
    });

    if (FilterKey.SORT in adjustedValue) {
      // skip default values in query string
      if (adjustedValue[FilterKey.SORT] === 'default') {
        adjustedValue[FilterKey.SORT] = undefined;
      }
    }

    const qs = stringify(adjustedValue, {
      arrayFormat: 'comma',
      skipNull: true,
    });

    return qs ? `?${qs}` : '';
  }

  protected static parseQueryString(value: string): object {
    const qsValue = value?.split?.('?')?.[1];
    if (!qsValue) {
      return {};
    }

    return parse(qsValue, { arrayFormat: 'comma' });
  }

  protected static parseFilterMap(input: object): FilterValuesObject {
    return parseFilterValues(input);
  }
}
